import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Grid, Typography, Button, Divider, Modal, CircularProgress, IconButton, useMediaQuery, useTheme, Select, MenuItem, FormControl, TextField, InputAdornment, Badge, Link } from "@mui/material";
import Stack from "@mui/material/Stack";
import API_MIDDLEWARE from "../../redux/api/middleware";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { setErrorMessage } from "../../redux/actions/appActions";
import { APP_CUSTOM_ERROR, ACCESS_TOKEN } from "../../constants/AppVarConstants";
import { READ_USER_VIDEOS, UPDATE_APPLICANT_VIEW_URL } from "../../redux/api/config";
import { getApplicantDetails, getB2BJobDetails, getB2BJobApplicants, getShareProfileApplicants, validateShareLink, validateSharePassword, updateJobAction, updateVideoAction, updateBestFitStatus, getApplicantReport, getApplicantPersonality, getApplicantTopicScore, getApplicantScoreBand, saveCommentApplicantView, clearApplicantDetails, saveJobViews, getOrganizationJobs, updatePrimaryStatus, updateReachoutStatus, recommendJobToCandidates } from "../../redux/actions/b2bActions";
import { SET_B2B_JOB_APPLICANTS } from "../../redux/actions/actionTypes";
import moment from "moment";
import VideoThumbnail from "../common/VideoThumbnail";
import ReactPlayer from "react-player";
import B2BHeader from "./B2BHeader";
import { ROUTE_PERSONALITY_PROFILER, ROUTE_COMPANY_JOB_DETAILS } from "../../constants/routes";
import { ArrowForward } from "@mui/icons-material";
import VideoDetailheader from "./videoDetailheader";
import Applicants from "./applicants";
import CommentPopup from "./comment";
import ReportView from "./ReportView";
import SharePopup from "./sharecandidate";
import ShareSuccessPopup from "./ShareSuccessPopup";
import RecommendJobModal from "./RecommendJobModal";
import ConfirmRecommendPopup from "./ConfirmRecommendPopup";


const styles = {
  subText: {
    fontSize: "16px",
    color: "#777777",
    fontWeight: "400",
  },
  text: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#000000",
  },
  tabStyle: {
    fontWeight: "bold",
  },
  indicator: {
    backgroundColor: "#756de9 !important",
    height: "4px",
  },
  modalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: 24,
  },

  modalContentDecline: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "300px",
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: 24,
  },
};

const ClientJobDetails = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const params = useParams();
  const location = useLocation();
  const jobId = params.jobId;
  const profileId = params.profileid;
  // const navigate = useNavigate();
  const { applicantDetails, b2bJobDetails, b2bJobApplicants, applicantReport, applicantPersonality, applicantTopicScore, applicantScoreBand, shareLinkValidation, sharePasswordValidation } = useSelector((state: any) => state.b2b);
  const userRole = useSelector((state: any) => state.app.userRole);
  const roles = localStorage.getItem("roles");

  const isSeeviAdmin = roles?.includes("seevi_admin") ?? false;
  const isCompanyJobDetailsRoute = location.pathname.startsWith(ROUTE_COMPANY_JOB_DETAILS);

  // Check if user has seevi_admin role to show Best Fit functionality
  // Hide Best Fit functionality when profileId is set (share profile view)
  const canShowBestFit = () => {
        return roles?.includes('seevi_admin') && !profileId;
  };
  
  const [hasMoreApplicants, setHasMoreApplicants] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [selectedApplicantDetails, setSelectedApplicantDetails] = useState<any>(null);
  const [selectedApplicantId, setSelectedApplicantId] = useState<number | null>(null);
  const [selectedCandidates, setSelectedCandidates] = useState<any[]>([]);
  const [applicants, setApplicants] = useState<any>([]);
  const [currentApplicantsPage, setCurrentApplicantsPage] = useState(1);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [loadingApplicantDetails, setLoadingApplicantDetails] = useState(false);
  const [organizationJobs, setOrganizationJobs] = useState<any[]>([]);
  const [loadingOrganizationJobs, setLoadingOrganizationJobs] = useState(false);
  const [activeApplicantsTab, setActiveApplicantsTab] = useState(0);
  const [activeTab1, setActiveTab1] = useState(0);
  const [currentActive, setCurrentActive] = useState(0);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openBestFitModal, setOpenBestFitModal] = useState(false);
  const [loadingBestFit, setLoadingBestFit] = useState(false);
  const [loadingShortlist, setLoadingShortlist] = useState(false);
  const [loadingReachout, setLoadingReachout] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openShareSuccessModal, setOpenShareSuccessModal] = useState(false);
  const [shareSuccessUrl, setShareSuccessUrl] = useState("");
  const [recommendJobModalOpen, setRecommendJobModalOpen] = useState(false);
  const [recommendPreSelectedIds, setRecommendPreSelectedIds] = useState<number[]>([]);
  const [confirmRecommendOpen, setConfirmRecommendOpen] = useState(false);
  const [recommendSubmitting, setRecommendSubmitting] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState('Account Management');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const [openReportView, setOpenReportView] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [linkExpired, setLinkExpired] = useState(false);
  const [isValidatingLink, setIsValidatingLink] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [isValidatingPassword, setIsValidatingPassword] = useState(false);
  const { userDetail, educationDetails, profileDetail, userCertificates, userExperience, userPersonality, userVideos } =
    applicantDetails;
  const [currentQuestionId, setCurrentQuestionId] = useState(-1);

  const { fullName, profileImage, dob, city, phoneNumber, email, gender } = userDetail || {};
  // const { videoUploaded, videoStatus } = profileStatus || {};
  const { languages, skills, tools, workLinks, work_links: workLinksSnake, workLink, work_link: workLinkSnake } =
    profileDetail || {};
  const resolvedApplicantWorkLinks: string[] = (() => {
    const fromArray = workLinks ?? workLinksSnake;
    if (Array.isArray(fromArray)) return fromArray.map((v: any) => String(v ?? "").trim()).filter(Boolean);
    const fromSingle = workLink ?? workLinkSnake;
    return fromSingle != null && String(fromSingle).trim() !== "" ? [String(fromSingle).trim()] : [];
  })();
  const formatApplicantWorkLinkHref = (raw: string) => {
    const t = String(raw).trim();
    if (!t) return "#";
    if (/^https?:\/\//i.test(t)) return t;
    return `https://${t}`;
  };

  const handleSelectApplicant = async (item: any, details: any) => {
    // Check if this is the same applicant being re-selected
    const isSameApplicant = selectedApplicant === item && 
      selectedApplicantId === (details?.applicationId || details?.userId);
    
    setSelectedApplicant(item);
    setSelectedApplicantDetails(details);
    setSelectedApplicantId(details?.applicationId || details?.userId);
    setCurrentActive(0); // Reset to first video when selecting new applicant

    // Only show loading and fetch data if it's a different applicant
    if (!isSameApplicant) {
      setLoadingApplicantDetails(true);
    }

    // Prefer latest record from Redux so repeated selection (e.g. while searching in Select) does not
    // treat the applicant as new again with stale `details` from a prior render.
    const latestRecord = b2bJobApplicants?.records?.find(
      (a: any) => a.applicationId === details?.applicationId
    );
    const applicantForViewCheck = latestRecord || details;

    // Check if applicant is new (applicationId not in viewedApplicants array)
    const isNewApplicant = Boolean(
      details?.applicationId &&
        (!applicantForViewCheck?.viewedApplicants ||
          !applicantForViewCheck.viewedApplicants.includes(details.applicationId))
    );

    // Update the applicant's viewedApplicants array in Redux state immediately (optimistic update)
    if (isNewApplicant && b2bJobApplicants?.records) {
      const updatedRecords = b2bJobApplicants.records.map((applicant: any) => {
        if (applicant.applicationId === details.applicationId) {
          return {
            ...applicant,
            isNew: false,
            viewedApplicants: applicant.viewedApplicants 
              ? [...applicant.viewedApplicants, details.applicationId]
              : [details.applicationId]
          };
        }
        return applicant;
      });

      dispatch({
        type: SET_B2B_JOB_APPLICANTS,
        payload: {
          ...b2bJobApplicants,
          records: updatedRecords
        }
      });
    }

    // Call API if applicant is new (fire and forget - state already updated)
    if (isNewApplicant && jobId && details?.applicationId) {
      API_MIDDLEWARE(
        UPDATE_APPLICANT_VIEW_URL,
        "POST",
        { "Content-Type": "application/json" },
        {
          jobId: parseInt(jobId),
          applicantId: details.applicationId
        }
      ).catch((err: any) => {
        // Silently fail - don't show error to user as this is a background update
        console.error("Error updating applicant view:", err);
        // Optionally revert the optimistic update on error
      });
    }
  };

  const handleVideoClick = (index: any, questionId: any) => {
    setCurrentActive(index);
    setCurrentQuestionId(questionId);
  };
  const fetchApplicants = (flag: boolean, resetOffset: boolean, jobAction = false) => {
    if (!flag) {
      setLoadingApplicants(true);
    }
    
    const page = jobAction ? currentApplicantsPage : resetOffset ? 1 : currentApplicantsPage + 1;
    
    // Check if this is a share profile route
    if (profileId) {
      // Use the share profile API
      dispatch(getShareProfileApplicants(profileId));
    } else if (jobId) {
      // Use the regular job applicants API
      dispatch(getB2BJobApplicants(jobId, page, 10000, ""));
    }
  };

  // Group applicants by status
  const groupedApplicants = React.useMemo(() => {
    if (!b2bJobApplicants?.records) return { APPLIED: [], SHORTLISTED: [] };
    
    // Debug: Log the API response
    console.log('B2B Job Applicants API Response:', b2bJobApplicants);
    console.log('Records:', b2bJobApplicants.records);
    
    // Records are deduped when stored (see getB2BJobApplicants) — handles API duplicate rows / mixed ID types
    const deduplicatedRecords = b2bJobApplicants.records;

    const grouped = deduplicatedRecords.reduce((acc: any, applicant: any) => {
      const status = applicant.applicationStatus;
      if (!acc[status]) {
        acc[status] = [];
      }
      acc[status].push(applicant);
      return acc;
    }, {});
    
    // Show all candidates in APPLIED tab regardless of status (already deduplicated)
    const allApplicants = deduplicatedRecords;
    
    return {
      APPLIED: allApplicants,
      SHORTLISTED: grouped.SHORTLIST || []
    };
  }, [b2bJobApplicants]);

  // Update applicants state when b2bJobApplicants changes
  React.useEffect(() => {
    if (b2bJobApplicants) {
      setApplicants(b2bJobApplicants.records || []);
      setCurrentApplicantsPage(b2bJobApplicants.page || 1);
      setHasMoreApplicants(b2bJobApplicants.hasNext || false);
      setLoadingApplicants(false);
    }
  }, [b2bJobApplicants]);

  useEffect(() => {
    // Clear previous applicant details when component loads or jobId changes
    dispatch(clearApplicantDetails());
    
    // Fetch job details when component loads
    if (jobId) {
      dispatch(getB2BJobDetails(jobId));
      
      // Save job view only if user is authenticated
      const accessToken = localStorage.getItem(ACCESS_TOKEN);
      if (accessToken) {
        dispatch(saveJobViews(
          parseInt(jobId),
          (response: any) => {
            console.log('Job view saved successfully:', response);
          },
          (error: any) => {
            console.error('Failed to save job view:', error);
          }
        ));
      }
    }
    
    // If this is a share profile route, validate the link first
    if (profileId) {
      setIsValidatingLink(true);
      dispatch(validateShareLink(
        profileId,
        (validationResult: any) => {
          setIsValidatingLink(false);
          if (!validationResult.isValid || validationResult.isExpired) {
            setLinkExpired(true);
          } else if (validationResult.isPasswordProtected) {
            setOpenPasswordModal(true);
          } else {
            // Link is valid and not password protected, fetch applicants
            fetchApplicants(false, true);
          }
        },
        (error: any) => {
          setIsValidatingLink(false);
          setLinkExpired(true);
        }
      ));
    } else {
      fetchApplicants(false, true);
    }
  }, [jobId, profileId, dispatch]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(clearApplicantDetails());
    };
  }, [dispatch]);

  useEffect(() => {
    if (applicants?.length) {
      // If we have a previously selected applicant ID, try to restore it
      if (selectedApplicantId) {
        const previouslySelectedApplicant = applicants.find(
          (app: any) => (app.applicationId === selectedApplicantId) || (app.userId === selectedApplicantId)
        );
        if (previouslySelectedApplicant) {
          setSelectedApplicant(previouslySelectedApplicant.userId);
          setSelectedApplicantDetails(previouslySelectedApplicant);
          setSelectedUserId(previouslySelectedApplicant.userId);
          return; // Exit early if we found and restored the previous selection
        }
      }
      
      // Don't automatically select first applicant on initial load
      // Let user explicitly select an applicant to see their details
    }
  }, [applicants, selectedApplicantId]);

  useEffect(() => {
    if (selectedApplicant) {
      dispatch(getApplicantDetails(selectedApplicant));
    }
  }, [selectedApplicant]);

  useEffect(() => {
    setCurrentQuestionId(userVideos?.[0]?.questionId);
  }, [userVideos]);

  // Turn off loading when applicant details are loaded
  useEffect(() => {
    if (applicantDetails && Object.keys(applicantDetails).length > 0) {
      setLoadingApplicantDetails(false);
    }
  }, [applicantDetails, userVideos]);

  // Fetch organization jobs when job details are loaded
  useEffect(() => {
    if (b2bJobDetails && b2bJobDetails.companyId) {
      setLoadingOrganizationJobs(true);
      dispatch(getOrganizationJobs(
        b2bJobDetails.companyId,
        (response: any) => {
          console.log('Organization jobs API response:', response);
          console.log('Response structure:', {
            response,
            result: response?.result,
            records: response?.result?.records,
            data: response?.data,
            jobs: response?.jobs
          });
          setOrganizationJobs(response?.result || []);
          setLoadingOrganizationJobs(false);
        },
        (error: any) => {
          console.error('Failed to fetch organization jobs:', error);
          setLoadingOrganizationJobs(false);
        }
      ));
    }
  }, [ dispatch]);

  const handleTabChange1 = (event: any, newValue: any) => {
    setActiveTab1(newValue);
  };

  const handleApplicantsTabChange = (newValue: number) => {
    setActiveApplicantsTab(newValue);
  };

  // State for handling the modal
  const [openModal, setOpenModal] = useState(false);
  const [openModalDecline, setOpenModalDecline] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModalDecline = () => setOpenModalDecline(true);
  const handleCloseModalDecline = () => setOpenModalDecline(false);

  const handleJobAction = (jobStatus: any) => {
    // Set loading state based on action
    if (jobStatus === "ACCEPTED") {
      setLoadingReachout(true);
    } else if (jobStatus === "DECLINED") {
      setLoadingDecline(true);
    }
    
    // Call reachout status API for "ACCEPTED" (Reach Out)
    if (jobStatus === "ACCEPTED") {
      dispatch(
        updateReachoutStatus(selectedApplicantDetails?.applicationId, () => {
          // Success callback
          setLoadingReachout(false);
          // Close modal after successful API call
          handleCloseModal();
          console.log('Reachout status updated successfully');
        }, () => {
          // Error callback
          setLoadingReachout(false);
          console.error('Failed to update reachout status');
        })
      );
      return;
    }
    
    dispatch(
      updateJobAction(jobStatus, selectedApplicantDetails?.applicationId, () => {
        // Reset loading states
        setLoadingReachout(false);
        setLoadingDecline(false);
        
        if (jobStatus === "DECLINED") {
          // Update local state instead of calling API for DECLINED
          const updatedApplicants = applicants.map((applicant: any) => 
            applicant.applicationId === selectedApplicantDetails.applicationId
              ? { ...applicant, applicationStatus: "DECLINED" }
              : applicant
          );
          setApplicants(updatedApplicants);
          
          // Update Redux store to reflect the changes
          dispatch({
            type: SET_B2B_JOB_APPLICANTS,
            payload: {
              ...b2bJobApplicants,
              records: updatedApplicants
            }
          });
          
          // Update selected applicant details
          setSelectedApplicantDetails((prev: any) => ({
            ...prev,
            applicationStatus: "DECLINED"
          }));
          
          handleCloseModalDecline();
        } else if (jobStatus === "APPLIED" && selectedApplicantDetails?.applicationStatus === "DECLINED") {
          // Handle accepting a declined candidate (changing from DECLINED to APPLIED)
          const updatedApplicants = applicants.map((applicant: any) => 
            applicant.applicationId === selectedApplicantDetails.applicationId
              ? { ...applicant, applicationStatus: "APPLIED" }
              : applicant
          );
          setApplicants(updatedApplicants);
          
          // Update Redux store to reflect the changes
          dispatch({
            type: SET_B2B_JOB_APPLICANTS,
            payload: {
              ...b2bJobApplicants,
              records: updatedApplicants
            }
          });
          
          // Update selected applicant details
          setSelectedApplicantDetails((prev: any) => ({
            ...prev,
            applicationStatus: "APPLIED"
          }));
          
          handleCloseModalDecline();
        } else if (jobStatus === "BEST_FIT") {
          toggleBestFitModal();
        }
        
        // Only call API for other statuses
        if (jobStatus !== "DECLINED" && !(jobStatus === "APPLIED" && selectedApplicantDetails?.applicationStatus === "DECLINED")) {
          fetchApplicants(false, true);
        }
      })
    );
  };

  const handleBestFitAction = () => {
    if (selectedApplicantDetails?.applicationId && !loadingBestFit) {
      setLoadingBestFit(true);
      const isBestFit = !selectedApplicantDetails?.isBestFit;
      dispatch(
        updateBestFitStatus(
          selectedApplicantDetails.applicationId, 
          isBestFit, 
          () => {
            // Success callback
            setLoadingBestFit(false);
            
            // Update local state instead of calling API
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, isBestFit: isBestFit }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              isBestFit: isBestFit
            }));
            
            toggleBestFitModal();
          },
          () => {
            // Error callback
            setLoadingBestFit(false);
          }
        )
      );
    }
  };

  const handleShortlistAction = () => {
    if (selectedApplicantDetails?.applicationId && !loadingShortlist) {
      setLoadingShortlist(true);
      
      // Check if we're in the shortlist tab and the candidate is already shortlisted
      if (activeApplicantsTab === 1 && selectedApplicantDetails?.applicationStatus === "SHORTLIST") {
        // Call primary status update API
        dispatch(
          updatePrimaryStatus(selectedApplicantDetails.applicationId, () => {
            // Success callback
            setLoadingShortlist(false);
            
            // Toggle the isPrimary status locally
            const newIsPrimary = !selectedApplicantDetails.isPrimary;
            
            console.log('Primary status updated:', {
              applicationId: selectedApplicantDetails.applicationId,
              oldIsPrimary: selectedApplicantDetails.isPrimary,
              newIsPrimary: newIsPrimary
            });
            
            // Update applicants list with new isPrimary status
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, isPrimary: newIsPrimary }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              isPrimary: newIsPrimary
            }));
            
            // The candidate will automatically move between sections due to the filtering logic
            // Primary candidates (isPrimary: true) will show in "Primary Candidate List"
            // Secondary candidates (isPrimary: false) will show in "Secondary Candidate List"
            
            console.log('Candidate moved to:', newIsPrimary ? 'Primary Candidate List' : 'Secondary Candidate List');
          }, () => {
            // Error callback
            setLoadingShortlist(false);
            console.error('Failed to update primary status');
          })
        );
      } else {
        // Original shortlist/remove shortlist logic
        const action = selectedApplicantDetails?.applicationStatus === "SHORTLIST" ? "APPLIED" : "SHORTLIST";
        dispatch(
          updateJobAction(action, selectedApplicantDetails.applicationId, () => {
            // Success callback
            setLoadingShortlist(false);
            
            // Update local state instead of calling API
            const newStatus = action;
            // New shortlisted candidates go to primary list by default; user can move to secondary
            const isNewShortlist = newStatus === "SHORTLIST";
            
            // Update applicants list
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, applicationStatus: newStatus, ...(isNewShortlist && { isPrimary: true }) }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              applicationStatus: newStatus,
              ...(isNewShortlist && { isPrimary: true })
            }));
          })
        );
      }
    }
  };

  const handleCommentIconClick = () => {
    // Clear badge count locally for selected applicant
    if (selectedApplicantDetails?.unreadCommentCount && selectedApplicantDetails.unreadCommentCount > 0) {
      // Update selected applicant details to clear unread count
      setSelectedApplicantDetails((prev: any) => ({
        ...prev,
        unreadCommentCount: 0
      }));
      
      // Update the applicants list to clear unread count for this applicant
      const updatedApplicants = applicants.map((applicant: any) => 
        applicant.applicationId === selectedApplicantDetails.applicationId
          ? { ...applicant, unreadCommentCount: 0 }
          : applicant
      );
      setApplicants(updatedApplicants);
      
      // Update Redux store to reflect the changes
      dispatch({
        type: SET_B2B_JOB_APPLICANTS,
        payload: {
          ...b2bJobApplicants,
          records: updatedApplicants,
          totalUnreadCommentCount: Math.max(0, (b2bJobApplicants?.totalUnreadCommentCount || 0) - selectedApplicantDetails.unreadCommentCount)
        }
      });
    }
    
    // Open comment modal
    toggleCommentModal();
    
    // Call API in background if applicant is selected
    if (selectedApplicantDetails?.applicationId) {
      dispatch(
        saveCommentApplicantView(
          selectedApplicantDetails.applicationId,
          jobId,
          () => {
            // Success callback - API call completed
            console.log('Comment applicant view saved successfully');
          },
          (error: any) => {
            // Error callback
            console.error('Failed to save comment applicant view:', error);
          }
        )
      );
    }
  };

  const calculateYears = (startDate: string, endDate?: string): string => {
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // Use current date if endDate is not provided

    let years = end.getFullYear() - start.getFullYear();
    const additionalMonths = end.getMonth() - start.getMonth();

    // Adjust years if the end month is earlier than the start month
    if (additionalMonths < 0 || (additionalMonths === 0 && end.getDate() < start.getDate())) {
      years -= 1;
    }

    return `${years} yrs`;
  };

  const formatDuration = (duration: string): string => {
    if (!duration) return ""; // Handle empty or invalid values

    const [value, unit] = duration.split(" - ");

    if (!value || !unit) return duration; // Return the original string if improperly formatted

    const formattedUnit =
      parseInt(value) > 1 && !unit.toLowerCase().endsWith("s")
        ? `${unit}s` // Pluralize by adding "s" if not already plural
        : unit;

    return `${value} ${formattedUnit}`;
  };

  const toggleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const toggleRejectModal = () => setOpenRejectModal(!openRejectModal);
  const toggleBestFitModal = () => setOpenBestFitModal(!openBestFitModal);
  const toggleCommentModal = () => setOpenCommentModal(!openCommentModal);
  const toggleShareModal = () => {
    setOpenShareModal(!openShareModal);
  };

  const handleRecommendClick = () => {
    if (isSeeviAdmin && isCompanyJobDetailsRoute) {
      if (selectedCandidates?.length > 0) {
        setConfirmRecommendOpen(true);
      } else {
        dispatch(setErrorMessage("Please select one or more candidates"));
      }
    } else {
      setRecommendJobModalOpen(true);
    }
  };

  const handleConfirmRecommend = (selectedJobId: number) => {
    const ids = selectedCandidates?.map((c) => c.userId).filter((id): id is number => id != null) ?? [];
    if (!selectedJobId || ids.length === 0) return;
    setRecommendSubmitting(true);
    dispatch(
      recommendJobToCandidates(
        selectedJobId,
        ids,
        () => {
          setRecommendSubmitting(false);
          setConfirmRecommendOpen(false);
          setSelectedCandidates([]);
          fetchApplicants(false, true);
        },
        () => {
          setRecommendSubmitting(false);
        }
      )
    );
  };

  const handleShareSuccess = (shareUrl: string) => {
    setShareSuccessUrl(shareUrl);
    setOpenShareSuccessModal(true);
  };

  const toggleShareSuccessModal = () => {
    setOpenShareSuccessModal(!openShareSuccessModal);
  };
  const toggleReportView = () => {
    setOpenReportView(!openReportView);
  };

  const handlePasswordSubmit = () => {
    if (!password.trim()) {
      setPasswordError('Please enter a password');
      return;
    }

    if (!profileId) {
      setPasswordError('Invalid share link');
      return;
    }

    setIsValidatingPassword(true);
    setPasswordError('');

    dispatch(validateSharePassword(
      profileId!,
      password,
      (validationResult: any) => {
        setIsValidatingPassword(false);
        if (validationResult.isPasswordValid && validationResult.isValid) {
          // Password is correct, close modal and fetch applicants
          setOpenPasswordModal(false);
          fetchApplicants(false, true);
        } else {
          // Password is incorrect
          setPasswordError('Incorrect password. Please try again.');
        }
      },
      (error: any) => {
        setIsValidatingPassword(false);
        setPasswordError('Password validation failed. Please try again.');
      }
    ));
  };

  const handleUserSelection = (userId: any) => {
    setSelectedUserId(userId);
    setSelectedApplicant(userId);
    setLoadingApplicantDetails(true);
    setCurrentActive(0); // Reset to first video when selecting new applicant
    const selectedUser = applicants.find((app: any) => app.userId === userId);
    if (selectedUser) {
      setSelectedApplicantDetails(selectedUser);
      setSelectedApplicantId(selectedUser?.applicationId || selectedUser?.userId);
    }
  };
  
  // Filter applicants based on search query (records deduped in getB2BJobApplicants)
  const filteredApplicants = React.useMemo(() => {
    const q = userSearchQuery.toLowerCase();
    if (!q.trim()) return applicants || [];
    return (applicants || []).filter((applicant: any) =>
      applicant.fullName?.toLowerCase().includes(q)
    );
  }, [applicants, userSearchQuery]);

  const handleVideoModal = (status: string) => {
    dispatch(
      updateVideoAction(status, currentQuestionId, selectedApplicantDetails?.userId, () => {
        if (status === "APPROVED") {
          toggleApproveModal();
        } else {
          toggleRejectModal();
        }
        dispatch(getApplicantDetails(selectedApplicant));
      })
    );
  };

  // Fix the helper function to correctly check if all videos are approved
  const areAllVideosApproved = (videos: any[]): boolean => {
    if (!videos || videos.length === 0) return false;
    return videos.every((video: any) => video.approvalStatus === "APPROVED");
  };

  // Approved videos only - show these in center pane; if none, show error
  const approvedVideos = React.useMemo(
    () => (userVideos || []).filter((v: any) => v?.approvalStatus === "APPROVED"),
    [userVideos]
  );
  const hasApprovedVideos = approvedVideos.length > 0;
  const hasVideosButNoneApproved = (userVideos?.length || 0) > 0 && !hasApprovedVideos;

  // Show expired link message
  if (linkExpired) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        padding: '20px'
      }}>
        <Box sx={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <Box sx={{ 
            width: "64px", 
            height: "64px", 
            backgroundColor: "#FFEBEE", 
            borderRadius: "50%", 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            margin: "0 auto 20px auto",
            border: "2px solid #FFCDD2"
          }}>
            <Typography sx={{ fontSize: "32px" }}>❌</Typography>
          </Box>
          <Typography variant="h5" sx={{ color: '#d32f2f', marginBottom: '16px', fontWeight: '600' }}>
            Link Expired
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', marginBottom: '24px' }}>
            This share link has expired or is no longer valid. Please contact the person who shared this link for a new one.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.close()}
            sx={{
              backgroundColor: '#756DE9',
              color: 'white',
              borderRadius: '8px',
              padding: '12px 24px',
              '&:hover': {
                backgroundColor: '#5f5bc4',
              }
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  }

  // Show loading while validating link
  if (isValidatingLink) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
        <Typography variant="h6" sx={{ color: '#666' }}>
          Validating share link...
        </Typography>
      </Box>
    );
  }

  // Show loading state for mobile when initially loading applicants
  if (isMobile && loadingApplicants && !b2bJobApplicants) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        position: 'relative'
      }}>
        {/* Mobile Header */}
        <Box sx={{
          backgroundColor: '#756DE9',
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src="/images/Seevi-Logo-White.png" alt="SeeVi" style={{ height: '20px' }} />
          </Box>
        </Box>

        {/* Loading Content */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          backgroundColor: '#f5f5f5'
        }}>
          <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
          <Typography variant="h6" sx={{ color: '#666', textAlign: 'center', marginBottom: '8px' }}>
            Loading applicants...
          </Typography>
          <Typography variant="body2" sx={{ color: '#999', textAlign: 'center' }}>
            Please wait while we fetch the applicant information
          </Typography>
        </Box>
      </Box>
    );
  }

  // Mobile/Tablet Layout
  if (isMobile) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        position: 'relative'
      }}>
        {/* Mobile Header */}
        <Box sx={{
          backgroundColor: '#756DE9',
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src="/images/Seevi-Logo-White.png" alt="SeeVi" style={{ height: '20px' }} />
          </Box>
          <Box sx={{ display: 'flex', gap: '8px' }}>
            <IconButton
              onClick={toggleShareModal}
              sx={{ color: 'white', padding: '4px' }}
            >
              <img src="/images/share.svg" width="18px" height="18px" alt="Share" />
            </IconButton>
            <IconButton sx={{ color: 'white', padding: '4px' }}>
              <img src="/images/close.svg" width="18px" height="18px" alt="Close" />
            </IconButton>
          </Box>
        </Box>

        {/* Account Management Dropdown with Share Button */}
        <Box sx={{ padding: '8px 16px 12px 16px', backgroundColor: '#756DE9', flexShrink: 0 }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            {/* Account Management Dropdown */}
            <FormControl sx={{ flex: 1 }}>
              <Select
                value={selectedAccount}
                onChange={(e) => setSelectedAccount(e.target.value)}
                displayEmpty
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiSelect-select': {
                    padding: '10px 12px',
                    fontSize: '13px',
                    color: '#666',
                  },
                  '& .MuiSelect-icon': {
                    color: '#666',
                  },
                }}
              >
                <MenuItem value="Account Management">Account Management</MenuItem>
                <MenuItem value="HR Management">HR Management</MenuItem>
                <MenuItem value="Recruitment">Recruitment</MenuItem>
                <MenuItem value="Talent Acquisition">Talent Acquisition</MenuItem>
              </Select>
            </FormControl>

            {/* Share Button */}
            <IconButton
              onClick={toggleShareModal}
              sx={{
                backgroundColor: '#E8E4FF',
                borderRadius: '8px',
                padding: '8px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  backgroundColor: '#D6D0FF',
                },
              }}
            >
              {/* Simple Share Icon - Three Connected Circles */}
              <Box sx={{ position: 'relative', width: '20px', height: '20px' }}>
                {/* Top Left Circle (slightly lower) */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '3px',
                    left: '2px',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    backgroundColor: '#756DE9',
                  }}
                />
                {/* Top Right Circle */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '1px',
                    right: '2px',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    backgroundColor: '#756DE9',
                  }}
                />
                {/* Bottom Center Circle */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '2px',
                    left: '50%',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    backgroundColor: '#756DE9',
                    transform: 'translateX(-50%)',
                  }}
                />
                {/* Connection Line - Top Left to Bottom Center */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '5px',
                    left: '4px',
                    width: '1px',
                    height: '10px',
                    backgroundColor: '#756DE9',
                    transform: 'rotate(25deg)',
                    transformOrigin: 'top',
                  }}
                />
                {/* Connection Line - Top Right to Bottom Center */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '3px',
                    right: '4px',
                    width: '1px',
                    height: '10px',
                    backgroundColor: '#756DE9',
                    transform: 'rotate(-25deg)',
                    transformOrigin: 'top',
                  }}
                />
              </Box>
            </IconButton>
          </Box>
        </Box>

        {/* Candidate Info with User Selection Dropdown */}
        <Box sx={{
          backgroundColor: '#756DE9',
          padding: '0 16px 12px 16px',
          flexShrink: 0
        }}>
          <FormControl fullWidth>
            <Select
              value={selectedUserId || selectedApplicant || ''}
              onChange={(e) => handleUserSelection(e.target.value)}
              displayEmpty
              sx={{
                backgroundColor: '#8B7ED8',
                borderRadius: '8px',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select': {
                  padding: '10px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                },
                '& .MuiSelect-icon': {
                  color: 'white',
                },
              }}
              renderValue={(value) => {
                const selectedUser = applicants.find((app: any) => app.userId === value);
                if (selectedUser) {
                  return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img
                        src={selectedUser.profilePicturePath || profileImage}
                        width="28px"
                        height="28px"
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                        alt="Profile"
                      />
                      <Typography sx={{
                        color: 'white',
                        fontSize: '15px',
                        fontWeight: '500'
                      }}>
                        {selectedUser.fullName || fullName}
                      </Typography>
                    </Box>
                  );
                }
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img
                      src={selectedApplicantDetails?.profilePicturePath || profileImage}
                      width="28px"
                      height="28px"
                      style={{ borderRadius: '50%', objectFit: 'cover' }}
                      alt="Profile"
                    />
                    <Typography sx={{
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '500'
                    }}>
                      {selectedApplicantDetails?.fullName || fullName}
                    </Typography>
                  </Box>
                );
              }}
              MenuProps={{
                autoFocus: false,
                PaperProps: {
                  sx: {
                    backgroundColor: '#8B7ED8',
                    borderRadius: '8px',
                    marginTop: '4px',
                    maxHeight: '300px',
                    '& .MuiMenuItem-root': {
                      color: 'white',
                      padding: '10px 12px',
                      '&:hover': {
                        backgroundColor: '#756DE9',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#756DE9',
                        '&:hover': {
                          backgroundColor: '#756DE9',
                        },
                      },
                    },
                  },
                },
              }}
            >
              {/* Search Input — stop propagation so Select does not treat keystrokes as selection changes */}
              <Box
                sx={{ padding: '8px 12px', borderBottom: '1px solid rgba(255,255,255,0.2)' }}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search users..."
                  value={userSearchQuery}
                  autoFocus
                  onChange={(e) => setUserSearchQuery(e.target.value)}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      borderRadius: '6px',
                      '& fieldset': {
                        border: '1px solid rgba(255,255,255,0.3)',
                      },
                      '&:hover fieldset': {
                        border: '1px solid rgba(255,255,255,0.5)',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid rgba(255,255,255,0.7)',
                      },
                    },
                    '& .MuiInputBase-input': {
                      color: 'white',
                      fontSize: '14px',
                      '&::placeholder': {
                        color: 'rgba(255,255,255,0.7)',
                        opacity: 1,
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src="/images/search.svg" width="16px" height="16px" alt="Search" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {/* Filtered Applicants List */}
              {filteredApplicants.length > 0 ? (
                filteredApplicants.map((applicant: any) => (
                  <MenuItem
                    key={applicant.applicationId ?? applicant.userId}
                    value={applicant.userId}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                      <img
                        src={applicant.profilePicturePath}
                        width="28px"
                        height="28px"
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                        alt="Profile"
                      />
                      <Typography sx={{
                        color: 'white',
                        fontSize: '15px',
                        fontWeight: '500'
                      }}>
                        {applicant.fullName}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  <Typography sx={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '14px',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    width: '100%'
                  }}>
                    No users found
                  </Typography>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>

        {/* Navigation Tabs */}
        <Box sx={{
          backgroundColor: '#756DE9',
          padding: '0 16px 12px 16px',
          flexShrink: 0
        }}>
          <Tabs
            value={activeTab1}
            onChange={handleTabChange1}
            variant="fullWidth"
            sx={{
              minHeight: '36px',
              '& .MuiTab-root': {
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '13px',
                fontWeight: '500',
                textTransform: 'none',
                minHeight: '36px',
                padding: '6px 8px',
              },
              '& .Mui-selected': {
                color: 'white !important',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#FF6B35',
                height: '2px',
              },
            }}
          >
            <Tab label="Video" />
            <Tab label="Profile" />
            <Tab label="Specialization" />
            <Tab label="Personality" />
          </Tabs>
        </Box>

        {/* Main Content Area */}
        <Box sx={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: 'white',
          width: '100%',
          minHeight: 0,
        }}>
          {loadingApplicantDetails ? (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '100%',
              flexDirection: 'column'
            }}>
              <CircularProgress size={40} />
              <Typography sx={{ mt: 2, color: '#666' }}>Loading applicant details...</Typography>
            </Box>
          ) : (
            <>
              {!selectedApplicant ? (
                // Show placeholder when no applicant is selected
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  padding: '40px 20px',
                  textAlign: 'center'
                }}>
                  <img src="/images/video-icon.png" alt="No applicant" style={{ width: '64px', height: '64px', opacity: 0.5, marginBottom: '20px' }} />
                  <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px', color: '#333' }}>
                    No applicant selected
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '300px' }}>
                    Select an applicant from the list to view their profile details, videos, and other information
                  </Typography>
                </Box>
              ) : (
                <>
                  {activeTab1 === 0 && (
                <Box>
              {/* Video Player */}
              <Box sx={{ position: 'relative', backgroundColor: '#000' }}>
                {hasApprovedVideos ? (
                  (() => {
                    const activeIndex = Math.min(currentActive, approvedVideos.length - 1);
                    const video = approvedVideos[activeIndex];
                    return video ? (
                      <ReactPlayer
                        height={250}
                        url={video?.videoPath}
                        width="100%"
                        controls
                        playing={false}
                      />
                    ) : null;
                  })()
                ) : hasVideosButNoneApproved ? (
                  <Box sx={{
                    height: 250,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    color: '#666',
                    padding: '20px'
                  }}>
                    <img src="/images/video-icon.png" alt="No approved videos" style={{ width: '64px', height: '64px', opacity: 0.5, marginBottom: '16px' }} />
                    <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
                      No approved videos
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#666', textAlign: 'center', maxWidth: '300px' }}>
                      This candidate&apos;s videos are under review. Once approved, you will be able to view them here.
                    </Typography>
                  </Box>
                ) : userVideos?.length ? null : (
                  <Box sx={{
                    height: 250,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    color: '#666'
                  }}>
                    <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5, marginBottom: '12px' }} />
                    <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: '500', marginBottom: '4px' }}>
                      No video selected
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#999', textAlign: 'center' }}>
                      Select an applicant to view their video responses
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Video Description for Mobile */}
              {hasApprovedVideos && (() => {
                const activeIndex = Math.min(currentActive, approvedVideos.length - 1);
                const video = approvedVideos[activeIndex];
                return video ? (
                  <Box sx={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                    <Typography variant="h6" fontSize={"14px"} sx={{ fontWeight: '600', marginBottom: '2px', lineHeight: 1.2 }}>
                      {video?.topic || "About You"}
                    </Typography>
                    <Typography variant="body2" fontSize={"12px"} sx={{ color: '#666', lineHeight: 1.3 }}>
                      {video?.question || "What do you think is your most unique trait and characteristics?"}
                    </Typography>
                  </Box>
                ) : null;
              })()}

              {/* Video Content Sections - Horizontal Scrollable Thumbnails */}
              <Box sx={{ padding: '12px' }}>
                {hasApprovedVideos ? (
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '12px',
                      overflowX: 'auto',
                      paddingBottom: '8px',
                      '&::-webkit-scrollbar': {
                        height: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '2px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#756DE9',
                        borderRadius: '2px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#5f5bc4',
                      },
                    }}
                  >
                    {approvedVideos?.map((el: any, index: number) => (
                      <Box
                        key={el?.questionId ?? index}
                        sx={{
                          cursor: 'pointer',
                          flex: approvedVideos.length <= 3 ? 1 : 'none',
                          minWidth: approvedVideos.length <= 3 ? 'auto' : '80px',
                          maxWidth: approvedVideos.length <= 3 ? 'none' : '80px',
                          borderRadius: '10px',
                          backgroundColor: currentActive === index ? '#E8E4FF' : '#F8F9FA',
                          border: currentActive === index ? '2px solid #756DE9' : '1px solid #E0E0E0',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            backgroundColor: currentActive === index ? '#E8E4FF' : '#F0F0F0',
                            border: currentActive === index ? '2px solid #756DE9' : '1px solid #D6D0FF',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          }
                        }}
                        onClick={() => handleVideoClick(index, el?.questionId)}
                      >
                        {/* Video Thumbnail Only */}
                        <Box
                          sx={{
                            position: 'relative',
                            width: '100%',
                            height: '180px',
                            borderRadius: '6px',
                            overflow: 'hidden',
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #E0E0E0'
                          }}
                        >
                          <VideoThumbnail videoUrl={el?.videoPath} />
                          {currentActive === index && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <img src="/images/Vector-play.png" width="10px" height="10px" alt="Playing" />
                            </Box>
                          )}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ) : hasVideosButNoneApproved ? (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '16px',
                    backgroundColor: '#fff8f8',
                    borderRadius: '8px',
                    border: '1px solid #ffcdd2'
                  }}>
                    <Typography sx={{ color: '#c62828', fontSize: '14px', fontWeight: '600' }}>
                      No approved videos yet
                    </Typography>
                    <Typography sx={{ color: '#666', fontSize: '12px', mt: 0.5, textAlign: 'center' }}>
                      Videos are under review. They will appear here once approved.
                    </Typography>
                  </Box>
                ) : userVideos?.length ? null : (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '200px',
                    flexDirection: 'column',
                    gap: '16px'
                  }}>
                    {selectedApplicant ? (
                      <>
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          No videos available for this applicant
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Videos will appear here once the applicant uploads them
                        </Typography>
                      </>
                    ) : (
                      <>
                        <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5 }} />
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          Select an applicant to view videos
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Choose an applicant from the list to see their video responses
                        </Typography>
                      </>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {activeTab1 === 1 && (
            <Box sx={{ padding: '12px' }}>
              {/* Demographics Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Demographics
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/dob.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Date of Birth: {moment(dob).format("DD/MM/YYYY")}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/complete-profile/Gender.svg" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Gender: {gender || '—'}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/language.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Language: {languages?.join(", ")}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src="/images/location.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Residence: {city}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Education Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Education
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {educationDetails?.map((el: any, id: any) => (
                    <Box key={id} sx={{ marginBottom: id < educationDetails.length - 1 ? '16px' : '0' }}>
                      <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                        {el?.educationType === "Board" ? el?.board : el?.courseName} | {el?.educationType === "Board" ? el?.schoolName : el?.institutionName}
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/degree.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              {el?.educationType === "Board" ? `Board: ${el?.board}` : `Degree: ${el?.courseName}`}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              {el?.yetToGraduate
                                ? `Duration: Studying since ${el?.startDate}`
                                : `Duration: ${calculateYears(el.startDate, el.endDate)}, ${el.startDate} - ${el.endDate || "Present"}`}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Grades.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Grades: {el?.percentage || 'N/A'}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                      {id < educationDetails.length - 1 && (
                        <Divider sx={{ marginTop: '12px', backgroundColor: '#E0E0E0' }} />
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Experience Section */}
              <Box>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Experience
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {userExperience?.map((el: any, id: any) => (
                    <Box key={id}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                            {el?.designationName} | {el?.companyName}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/degree.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Function: {el?.departmentName || 'N/A'}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Job Type: Full-Time
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/location.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Work Mode: Hybrid
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Duration: {!el?.endDate
                                ? `${calculateYears(el?.startDate, new Date().toISOString())}, Currently Working Here`
                                : `${calculateYears(el.startDate, el.endDate)}, ${moment(el?.startDate).format("YYYY")} - ${moment(el?.endDate).format("YYYY")}`}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                            Description
                          </Typography>
                          <Typography sx={{ fontSize: '11px', color: '#666', lineHeight: 1.4 }}>
                            {el?.description || 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.'}
                          </Typography>
                        </Grid>
                      </Grid>
                      {id < userExperience.length - 1 && (
                        <Divider sx={{ marginTop: '16px', marginBottom: '16px', backgroundColor: '#E0E0E0' }} />
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          )}

          {activeTab1 === 2 && (
            <Box sx={{ padding: '12px' }}>
              {/* Skill-sets Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Skill-sets
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4 }}>
                    {skills?.join(" | ")}
                  </Typography>
                </Box>
              </Box>

              {/* Tools Known Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                  Tools Known
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4 }}>
                  {tools?.join(" | ")}
                </Typography>
              </Box>

              <Box sx={{ marginBottom: "20px" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1F2235", marginBottom: "8px" }}>
                  Work link
                </Typography>
                {resolvedApplicantWorkLinks.length ? (
                  <Stack direction="column" spacing={0.75}>
                    {resolvedApplicantWorkLinks.map((wl: string, i: number) => (
                      <Link
                        key={`${wl}-${i}`}
                        href={formatApplicantWorkLinkHref(wl)}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ fontSize: "12px", color: "#756DE9", wordBreak: "break-all" }}
                      >
                        {wl}
                      </Link>
                    ))}
                  </Stack>
                ) : (
                  <Typography sx={{ fontSize: "12px", color: "#999", fontStyle: "italic", lineHeight: 1.4 }}>
                    Not added
                  </Typography>
                )}
              </Box>

              {/* Certifications Section */}
              <Box>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Certifications
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  <Grid container spacing={2}>
                    {userCertificates?.map((el: any, index: number) => (
                      <Grid item xs={6} key={index}>
                        <Box sx={{ marginBottom: index < userCertificates.length - 1 ? '16px' : '0' }}>
                          <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                            {el?.certificateName} | {el?.institute}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Duration: {el?.courseDuration && formatDuration(el.courseDuration)}
                            </Typography>
                          </Box>
                          {el?.courseExpiry && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                              <img src="/images/complete-profile/Course Expiry Date.svg" width="14px" height="14px" />
                              <Typography sx={{ fontSize: '11px', color: '#666' }}>
                                Course Expiry Date: {moment(el?.courseExpiry)?.format("DD/MM/YYYY")}
                              </Typography>
                            </Box>
                          )}
                          {el?.certificateReceived && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <img src="/images/Tick.png" width="14px" height="14px" />
                              <Typography sx={{ fontSize: '11px', color: '#666' }}>
                                Received Certificate
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Box>
          )}

          {activeTab1 === 3 && (
            <Box sx={{
              padding: '12px',
              textAlign: 'center',
              position: 'relative',
              zIndex: 1002,
              pointerEvents: 'auto'
            }}>
              <img src="/images/connector-image.png" alt="Connector" width="100px" style={{ marginBottom: '12px' }} />
              <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                {userPersonality?.map((el: any) => el?.displayPersonalityType).join(", ")}
              </Typography>
              <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4, marginBottom: '16px' }}>
                {userPersonality?.map((el: any) => el?.typeDescriptors).join(" ")}
              </Typography>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('Button clicked - opening report view');
                  toggleReportView();
                }}
                sx={{
                  color: '#756DE9',
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  margin: '0 auto',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  border: '1px solid #756DE9',
                  backgroundColor: 'transparent',
                  minHeight: '48px',
                  zIndex: 1001,
                  position: 'relative',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#F8F7FF',
                    border: '1px solid #756DE9',
                  },
                  '&:active': {
                    backgroundColor: '#E8E4FF',
                    transform: 'scale(0.98)',
                  },
                }}
              >
                View Full Report
                <ArrowForward sx={{ fontSize: '14px' }} />
              </Button>
            </Box>
          )}
                </>
              )}
            </>
          )}
        </Box>

        {/* Mobile Bottom Navigation */}
        <Box sx={{
          backgroundColor: '#1F2235',
          padding: '8px 12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: '1px solid #333',
          flexShrink: 0
        }}>
          {false && (
          <Button
            onClick={toggleCommentModal}
            sx={{
              color: 'white',
              fontSize: '12px',
              fontWeight: '500',
              textTransform: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              flex: 1,
              justifyContent: 'center',
              padding: '8px 4px'
            }}
          >
            <img src="/images/comment_white.svg" width="14px" height="14px" alt="Comment" />
            Comment
          </Button>
          )}

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              backgroundColor: 'white',
              height: '100%',
              minHeight: '20px',
              margin: '0 8px',
              alignSelf: 'stretch'
            }}
          />

          <Button
            onClick={handleOpenModal}
            sx={{
              color: 'white',
              fontSize: '12px',
              fontWeight: '500',
              textTransform: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              flex: 1,
              justifyContent: 'center',
              padding: '8px 4px'
            }}
          >
            <img src="/images/client-website/reach-out.png" width="14px" height="14px" alt="Reach Out" />
            Reach Out
          </Button>
        </Box>


        {/* Comment Popup */}
        <CommentPopup
          open={openCommentModal}
          onClose={toggleCommentModal}
          jobId={jobId ? parseInt(jobId) : undefined}
          receiverId={selectedApplicantDetails?.userId}
        />

        {/* Best Fit Modal */}
        {canShowBestFit() && (
        <Modal open={openBestFitModal} onClose={toggleBestFitModal}>
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "400px",
            backgroundColor: "white",
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
            outline: "none",
          }}>
            {/* Header with icon */}
            <Box sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <Box sx={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#E8F5E8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "16px",
              }}>
                <img src="/images/Tick.png" width="24px" height="24px" alt="Best Fit" />
              </Box>
              <Typography variant="h5" component="h2" sx={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1F2235",
                margin: 0,
              }}>
                {selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'}
              </Typography>
            </Box>

            {/* Description */}
            <Typography sx={{
              fontSize: "14px",
              color: "#666666",
              marginBottom: "20px",
              lineHeight: 1.5,
            }}>
              {selectedApplicantDetails?.isBestFit 
                ? 'Are you sure you want to remove this candidate from the best fit status? This action will remove their top choice highlight.'
                : 'Are you sure you want to mark this candidate as the best fit for this position? This action will highlight them as your top choice.'
              }
            </Typography>

            {/* Candidate Info */}
            <Box sx={{
              display: "flex",
              alignItems: "center",
              padding: "16px",
              borderRadius: "12px",
              backgroundColor: "#F8F9FA",
              border: "1px solid #E8F5E8",
              marginBottom: "24px",
            }}>
              <img
                src={selectedApplicantDetails?.profilePicturePath}
                width="50px"
                height="50px"
                style={{ borderRadius: "50%", objectFit: "cover" }}
                alt="Candidate"
              />
              <Box sx={{ marginLeft: "12px", flex: 1 }}>
                <Typography sx={{
                  fontSize: "16px",
                  color: "#1F2235",
                  fontWeight: "500",
                  marginBottom: "4px",
                }}>
                  {selectedApplicantDetails?.fullName}
                </Typography>
                <Box sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}>
                  <img src="/images/Tick.png" width="12px" height="12px" style={{ marginRight: "4px" }} />
                  BEST FIT CANDIDATE
                </Box>
              </Box>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
              <Button
                onClick={toggleBestFitModal}
                disabled={loadingBestFit}
                variant="outlined"
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#666666",
                  padding: "10px 24px",
                  textTransform: "none",
                  opacity: loadingBestFit ? 0.7 : 1,
                  "&:hover": {
                    borderColor: "#CCCCCC",
                    backgroundColor: "#F5F5F5",
                  },
                  "&:disabled": {
                    borderColor: "#E0E0E0",
                    color: "#666666",
                  },
                }}
              >
                Cancel
              </Button>
                <Button
                  onClick={handleBestFitAction}
                  disabled={loadingBestFit}
                  sx={{
                    backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: selectedApplicantDetails?.isBestFit ? "10px 32px" : "10px 24px",
                    minWidth: selectedApplicantDetails?.isBestFit ? "180px" : "auto",
                    textTransform: "none",
                    opacity: loadingBestFit ? 0.7 : 1,
                    "&:hover": {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#d32f2f" : "#45a049",
                    },
                    "&:disabled": {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                      color: "#fff",
                    },
                  }}
                >
                  {loadingBestFit ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={16} sx={{ color: '#fff' }} />
                      <Typography sx={{ fontSize: '14px' }}>
                        {selectedApplicantDetails?.isBestFit ? 'Removing...' : 'Marking...'}
                      </Typography>
                    </Box>
                  ) : (
                    selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'
                  )}
              </Button>
            </Box>
          </Box>
        </Modal>
        )}
      </Box>
    );
  }

  // Show loading state when initially loading applicants
  if (loadingApplicants && !b2bJobApplicants) {
    return (
      <Box>
        <VideoDetailheader 
          jobDetails={b2bJobDetails} 
          jobId={jobId} 
          profileId={profileId}
          organizationJobs={organizationJobs}
          loadingOrganizationJobs={loadingOrganizationJobs}
        />
        <Box sx={{ display: 'flex', height: 'calc(100vh - 160px)', m: 1 }}>
          {/* Section 1 - Left */}
          <Box sx={{
            flex: 1,
            marginRight: '8px',
            marginTop: '8px',
            paddingLeft: '8px',
            backgroundColor: '#fafafa',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
            <Typography variant="h6" sx={{ color: '#666', textAlign: 'center' }}>
              Loading applicants...
            </Typography>
          </Box>
          
          {/* Section 2 - Center - Show loading state */}
          <Box sx={{
            flex: 2,
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            marginLeft: '16px',
            marginRight: '16px',
            backgroundColor: '#fafafa',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}>
            <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
            <Typography variant="h6" sx={{ color: '#666', textAlign: 'center' }}>
              Loading applicant details...
            </Typography>
          </Box>
          
          {/* Section 3 - Right - Show loading state */}
          <Box sx={{
            flex: 1,
            marginLeft: '8px',
            marginTop: '8px',
            paddingRight: '8px',
            backgroundColor: '#fafafa',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CircularProgress size={40} sx={{ color: '#756DE9' }} />
          </Box>
        </Box>
      </Box>
    );
  }

  // Desktop Layout
  return (
    <Box>
      <VideoDetailheader 
          jobDetails={b2bJobDetails} 
          jobId={jobId} 
          profileId={profileId}
          organizationJobs={organizationJobs}
          loadingOrganizationJobs={loadingOrganizationJobs}
        />
      {/* Three horizontal sections */}
      <Box sx={{ display: 'flex', height: 'calc(100vh - 160px)', m: 1 }}>
        {/* Section 1 - Left */}
        <Box sx={{
          flex: 1,
          marginRight: '8px',
          marginTop: '8px',
          paddingLeft: '8px',
          backgroundColor: '#fafafa'
        }}>
          <Applicants 
            onCommentClick={() => { }} 
            onShareClick={toggleShareModal} 
            onRecommendClick={handleRecommendClick}
            onSelectApplicant={handleSelectApplicant}
            onCheckboxChange={setSelectedCandidates}
            onTabChange={handleApplicantsTabChange}
            groupedApplicants={groupedApplicants}
            loading={loadingApplicants}
            selectedApplicantId={selectedApplicantId}
            selectedCandidates={selectedCandidates}
            totalUnreadCommentCount={(() => {
              const count = b2bJobApplicants?.totalUnreadCommentCount || 0;
              console.log('Passing totalUnreadCommentCount to Applicants:', count);
              console.log('b2bJobApplicants object:', b2bJobApplicants);
              return count;
            })()}
            hideComment={true}
            hideRecommend={!!profileId || !(isSeeviAdmin && isCompanyJobDetailsRoute)}
          />
          {/* Content for section 1 */}
        </Box>

        {/* Section 2 - Center */}
        <Box sx={{
          flex: 2,
          minHeight: 0,
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          marginLeft: '16px',
          marginRight: '16px',
          backgroundColor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "#756DE9",
              padding: "10px",
              borderTopRightRadius: "10px",
              borderTopLeftRadius: "10px",
              justifyContent: "space-between"
            }}
          >
            <Box display={"flex"}>
              <img 
                src={selectedApplicantDetails?.profilePicturePath || profileImage} 
                width="50px" 
                height="50px"
                style={{ borderRadius: '50%', objectFit: 'cover' }}
              />
              <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                <Typography sx={{ fontSize: "18px", color: "#fff", fontWeight: "500", fontFamily: "DM Sans" }}>
                  {selectedApplicantDetails?.fullName || fullName}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#fff", fontWeight: "400" }}>
                  {educationDetails?.some((el: any) => el?.yetToGraduate) ? "Studying Currently" : null}
                </Typography>
              </Grid>
            </Box>
            {/* Action buttons */}
            <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
              {/* Best Fit Button */}
              {selectedApplicantDetails && canShowBestFit() && (
                <Button
                  onClick={toggleBestFitModal}
                  disabled={loadingBestFit}
                  sx={{
                    backgroundColor: selectedApplicantDetails?.isBestFit ? '#f44336' : '#4CAF50',
                    color: '#fff',
                    borderRadius: '20px',
                    width: selectedApplicantDetails?.isBestFit ? '120px' : '60px',
                    height: '36px',
                    minWidth: selectedApplicantDetails?.isBestFit ? '120px' : '60px',
                    boxShadow: selectedApplicantDetails?.isBestFit ? '0 2px 8px rgba(244, 67, 54, 0.3)' : '0 2px 8px rgba(76, 175, 80, 0.3)',
                    '&:hover': {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? '#d32f2f' : '#45a049',
                      boxShadow: selectedApplicantDetails?.isBestFit ? '0 4px 12px rgba(244, 67, 54, 0.4)' : '0 4px 12px rgba(76, 175, 80, 0.4)',
                      transform: 'scale(1.02)',
                    },
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px',
                    opacity: loadingBestFit ? 0.7 : 1,
                  }}
                >
                  {loadingBestFit ? (
                    <CircularProgress size={16} sx={{ color: '#fff' }} />
                  ) : (
                    <Typography
                      sx={{
                        fontSize: '10px',
                        fontWeight: '600',
                        lineHeight: 1,
                        textTransform: 'uppercase',
                      }}
                    >
                      {selectedApplicantDetails?.isBestFit ? 'Remove Best Fit' : 'Best Fit'}
                    </Typography>
                  )}
                </Button>
              )}

              {/* Comment view button */}
              {false && (
              <Badge
                badgeContent={selectedApplicantDetails?.unreadCommentCount || 0}
                color="error"
                invisible={!selectedApplicantDetails?.unreadCommentCount || selectedApplicantDetails?.unreadCommentCount === 0}
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: '10px',
                    height: '16px',
                    minWidth: '16px',
                    borderRadius: '8px',
                  }
                }}
              >
                <IconButton
                  onClick={handleCommentIconClick}
                  sx={{
                    backgroundColor: "#AAA7E44D",
                    borderRadius: "6px",
                    p: "4px",
                    height: "38px",
                    width: "38px",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#AAA7E466",
                    },
                  }}
                >
                  <img
                    src="/images/comment_white.svg"
                    color="white"
                    width="20px"
                    height="20px"
                  ></img>
                </IconButton>
              </Badge>
              )}
            </Box>
          </Grid>

          {/* Scrollable content area */}
          <Box sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#c1c1c1",
              borderRadius: "3px",
              "&:hover": {
                backgroundColor: "#a8a8a8",
              },
            },
          }}>
            {loadingApplicantDetails ? (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                backgroundColor: "#fff"
              }}>
                <CircularProgress size={40} />
                <Typography sx={{ ml: 2, color: '#666' }}>Loading applicant details...</Typography>
              </Box>
            ) : !selectedApplicant ? (
              // Show placeholder when no applicant is selected
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: '60px 40px',
                textAlign: 'center',
                backgroundColor: "#fff"
              }}>
                <img src="/images/profile-avatar.png" alt="No applicant" style={{ width: '80px', height: '80px', opacity: 0.5, marginBottom: '24px' }} />
                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px', color: '#333' }}>
                  No applicant selected
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '400px' }}>
                  Select an applicant from the list to view their profile details and specializations
                </Typography>
              </Box>
            ) : (
              <Box sx={{ backgroundColor: "#fff" }}>
                {userVideos?.length ? (
                  <>
                    {/* Main Video Player */}
                    <Box sx={{ position: 'relative', backgroundColor: '#000', marginBottom: '16px' }}>
                      {hasApprovedVideos ? (
                        (() => {
                          const activeIndex = Math.min(currentActive, approvedVideos.length - 1);
                          const video = approvedVideos[activeIndex];
                          return video ? (
                            <ReactPlayer
                              height={350}
                              url={video?.videoPath}
                              width="100%"
                              controls
                              playing={false}
                            />
                          ) : null;
                        })()
                      ) : hasVideosButNoneApproved ? (
                        <Box sx={{
                          height: 350,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          color: '#666',
                          padding: '24px'
                        }}>
                          <img src="/images/video-icon.png" alt="No approved videos" style={{ width: '80px', height: '80px', opacity: 0.5, marginBottom: '20px' }} />
                          <Typography variant="h6" sx={{ fontSize: '20px', fontWeight: '600', marginBottom: '12px', color: '#333' }}>
                            No approved videos
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '16px', color: '#666', textAlign: 'center', maxWidth: '400px', lineHeight: 1.6 }}>
                            This candidate&apos;s videos are under review. Once approved, you will be able to view them here.
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{
                          height: 350,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          color: '#666'
                        }}>
                          <img src="/images/video-icon.png" alt="No video" style={{ width: '64px', height: '64px', opacity: 0.5, marginBottom: '16px' }} />
                          <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px' }}>
                            No video selected
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '16px', color: '#999', textAlign: 'center' }}>
                            Select an applicant to view their video responses
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Video Description */}
                    {hasApprovedVideos && (() => {
                      const activeIndex = Math.min(currentActive, approvedVideos.length - 1);
                      const video = approvedVideos[activeIndex];
                      return video ? (
                        <>
                          <Box sx={{ padding: '8px 16px' }}>
                            <Typography variant="h6" fontSize={"14px"} sx={{ fontWeight: '600', marginBottom: '2px', lineHeight: 1.2 }}>
                              {video?.topic || "About You"}
                            </Typography>
                            <Typography variant="body2" fontSize={"12px"} sx={{ color: '#666', lineHeight: 1.3 }}>
                              {video?.question || "What do you think is your most unique trait and characteristics?"}
                            </Typography>
                          </Box>
                          <Divider />
                        </>
                      ) : null;
                    })()}

                    {/* Video List - Horizontal Scrollable Thumbnails */}
                    <Box sx={{ padding: '16px' }}>
                      {hasApprovedVideos ? (
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '16px',
                            overflowX: 'auto',
                            paddingBottom: '8px',
                            '&::-webkit-scrollbar': {
                              height: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                              borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#756DE9',
                              borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#5f5bc4',
                            },
                          }}
                        >
                          {approvedVideos?.map((el: any, index: number) => (
                            <Box
                              key={el?.questionId ?? index}
                              sx={{
                                cursor: 'pointer',
                                flex: approvedVideos.length <= 3 ? 1 : 'none',
                                minWidth: approvedVideos.length <= 3 ? 'auto' : '120px',
                                maxWidth: approvedVideos.length <= 3 ? 'none' : '120px',
                                borderRadius: '12px',
                                backgroundColor: currentActive === index ? '#E8E4FF' : '#F8F9FA',
                                border: currentActive === index ? '2px solid #756DE9' : '1px solid #E0E0E0',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '&:hover': {
                                  backgroundColor: currentActive === index ? '#E8E4FF' : '#F0F0F0',
                                  border: currentActive === index ? '2px solid #756DE9' : '1px solid #D6D0FF',
                                  transform: 'translateY(-2px)',
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                }
                              }}
                              onClick={() => handleVideoClick(index, el?.questionId)}
                            >
                              {/* Video Thumbnail Only */}
                              <Box
                                sx={{
                                  position: 'relative',
                                  width: '100%',
                                  height: '200px',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px solid #E0E0E0'
                                }}
                              >
                                <VideoThumbnail videoUrl={el?.videoPath} />
                                {currentActive === index && (
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      backgroundColor: 'rgba(0,0,0,0.7)',
                                      borderRadius: '50%',
                                      width: '24px',
                                      height: '24px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <img src="/images/Vector-play.png" width="12px" height="12px" alt="Playing" />
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ) : hasVideosButNoneApproved ? (
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '24px',
                          backgroundColor: '#fff8f8',
                          borderRadius: '8px',
                          border: '1px solid #ffcdd2'
                        }}>
                          <Typography sx={{ color: '#c62828', fontSize: '16px', fontWeight: '600' }}>
                            No approved videos yet
                          </Typography>
                          <Typography sx={{ color: '#666', fontSize: '14px', mt: 1, textAlign: 'center', maxWidth: '360px' }}>
                            This candidate&apos;s videos are under review. They will appear here once approved.
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>
                  </>
                ) : (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '200px',
                    flexDirection: 'column',
                    gap: '16px'
                  }}>
                    {selectedApplicant ? (
                      <>
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          No videos available for this applicant
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Videos will appear here once the applicant uploads them
                        </Typography>
                      </>
                    ) : (
                      <>
                        <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5 }} />
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          Select an applicant to view videos
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Choose an applicant from the list to see their video responses
                        </Typography>
                      </>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </Box>
          {/* Content for section 2 */}
        </Box>

        {/* Section 3 - Right */}
        <Box sx={{
          flex: 2,
          minHeight: 0,
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <Tabs
            value={activeTab1}
            onChange={handleTabChange1}
            TabIndicatorProps={{
              style: { backgroundColor: "#756de9", height: "2px", borderRadius: "2px" }, // Adjust this as needed
            }}
            variant="fullWidth"
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              backgroundColor: "white",
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              "& .MuiTab-root": {
                fontSize: "14px",
                fontWeight: "500",
                color: "#000",
              },
              "& .Mui-selected": {
                color: "#756de9", // Change color of the selected tab text
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#756de9 !important", // Ensure the indicator is visible
              },
            }}
          >
            <Tab label="PROFILE DETAILS" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
            <Tab label="SPECIALIZATION" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
            <Tab label="PERSONALITY" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
          </Tabs>

          {/* Content area that will grow */}
          <Box sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
            paddingBottom: '60px', // Add padding for fixed Best Fit button
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#fafafa", // very light grey
              borderRadius: "4px",
            },
          }}>
            {loadingApplicantDetails ? (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                backgroundColor: "#fff"
              }}>
                <CircularProgress size={40} />
                <Typography sx={{ ml: 2, color: '#666' }}>Loading profile details...</Typography>
              </Box>
            ) : !selectedApplicant ? (
              // Show placeholder when no applicant is selected
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: '60px 40px',
                textAlign: 'center',
                backgroundColor: "#fff"
              }}>
                <img src="/images/profile-avatar.png" alt="No applicant" style={{ width: '80px', height: '80px', opacity: 0.5, marginBottom: '24px' }} />
                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px', color: '#333' }}>
                  No applicant selected
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '400px' }}>
                  Select an applicant from the list to view their profile details and specializations
                </Typography>
              </Box>
            ) : (
              <>
                {/* Profile Details Content */}
            {activeTab1 === 0 && (
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "8px",
                  textAlign: "center",
                  borderRadius: "10px",
                }}
              >
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Demographics
                  </Typography>

                  <Stack style={{ marginTop: "10px" }} direction="column" spacing={1}>
                    <Stack direction="row" spacing={1}>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/dob.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {moment(dob).format("DD/MM/YYYY")}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/location.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {city}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/complete-profile/Gender.svg" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {gender || '—'}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "50%" }}
                      >
                        <img src="/images/language.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {languages?.join(", ")}
                        </Typography>
                      </Stack>
                      {userExperience?.length > 1 ? (
                        <Stack
                          direction="column"
                          spacing={1}
                          sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "50%" }}
                        >
                          <img src="/images/client-website/id-image.png" width="20px"></img>
                          <Typography
                            style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}
                          >
                            Currently Working
                          </Typography>
                        </Stack>
                      ) : null}
                    </Stack>
                  </Stack>
                </Box>
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Education
                  </Typography>

                  <Grid container spacing={2} style={{ marginTop: "-5px" }}>
                    {educationDetails?.map((el: any, id: any) => {
                      return (
                        <Grid item xs={6} key={id}>
                          <Stack
                            direction="column"
                            spacing={0.5}
                            sx={{
                              border: "1px solid #C4C4C44D",
                              borderRadius: "5px",
                              padding: "10px",
                            }}
                          >
                            <Typography
                              style={{ color: "#222222", fontSize: "14px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.educationType === "Board" ? el?.board : el?.courseName}
                            </Typography>
                            <Typography
                              style={{ color: "#1F2235", fontSize: "12px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.educationType === "Board" ? el?.schoolName : el?.institutionName}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/Calendar-new.png" width="20px" />
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {el?.yetToGraduate
                                  ? `Studying since ${el?.startDate}`
                                  : el?.startDate &&
                                  `${calculateYears(el.startDate, el.endDate)}, ${el.startDate} - ${el.endDate || "Present"
                                  }`}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Experiences
                  </Typography>
                  {userExperience?.map((el: any, id: any) => {
                    return (
                      <Stack key={id} style={{ marginTop: "10px" }} direction="column" spacing={1}>
                        <Stack direction="row" spacing={1}>
                          <Stack
                            direction="column"
                            spacing={0.5}
                            sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "100%" }}
                          >
                            <Typography
                              style={{ color: "#222222", fontSize: "14px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.companyName}
                            </Typography>
                            <Typography
                              style={{ color: "#1F2235", fontSize: "12px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.designationName}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/client-website/people-icon.png" width="20px"></img>
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {el?.departmentName}
                              </Typography>
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/Calendar-new.png" width="20px"></img>
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {!el?.endDate
                                  ? `${moment(el?.startDate).format("DD/MM/YYYY")} - Currently Working Here`
                                  : `${moment(el?.startDate).format("DD/MM/YYYY")} - ${moment(el?.endDate).format(
                                    "DD/MM/YYYY"
                                  )}`}
                              </Typography>
                            </Stack>
                            {el?.workLink && (
                              <Stack direction="row" style={{ marginTop: "-2px" }} alignItems="flex-start" sx={{ width: "100%" }}>
                                <img src="/images/link.png" style={{ width: "40px", flexShrink: 0, marginLeft: "-8px", marginRight: "-4px" }} alt="" />
                                <Box
                                  component="a"
                                  href={el.workLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    minWidth: 0,
                                    flex: 1,
                                    color: "#1976d2",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    textDecoration: "underline",
                                    textAlign: "left",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {el.workLink}
                                </Box>
                              </Stack>
                            )}
                            <Typography
                              style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                            >
                              {el?.description}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    );
                  })}
                </Box>
              </Box>
            )}

            {/* Specialization Content */}
            {activeTab1 === 1 && (
              <Box style={{ borderRadius: "10px", padding: "8px", marginBottom: "10px" }} className="">
                <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>Skill Set</Typography>

                <Stack direction="column" marginBottom="20px">
                  <Typography style={{ color: "#555555", fontSize: "14px" }}>
                    {skills?.map((tool: string, index: number) => (
                      <React.Fragment key={index}>
                        <span>{tool}</span>
                        {index !== skills.length - 1 && <span style={{ color: "orange" }}> | </span>}
                      </React.Fragment>
                    ))}
                  </Typography>

                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", margin: "10px 0px" }}>
                    Tools Known
                  </Typography>

                  <Typography style={{ color: "#555555", fontSize: "14px" }}>
                    {tools?.map((tool: string, index: number) => (
                      <React.Fragment key={index}>
                        <span>{tool}</span>
                        {index !== tools.length - 1 && <span style={{ color: "orange" }}> | </span>}
                      </React.Fragment>
                    ))}
                  </Typography>

                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", margin: "12px 0px 4px" }}>
                    Work link
                  </Typography>
                  {resolvedApplicantWorkLinks.length ? (
                    <Stack direction="column" spacing={0.75}>
                      {resolvedApplicantWorkLinks.map((wl: string, i: number) => (
                        <Link
                          key={`${wl}-${i}`}
                          href={formatApplicantWorkLinkHref(wl)}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ fontSize: "14px", wordBreak: "break-all" }}
                        >
                          {wl}
                        </Link>
                      ))}
                    </Stack>
                  ) : (
                    <Typography style={{ color: "#999999", fontSize: "14px", fontStyle: "italic" }}>Not added</Typography>
                  )}
                </Stack>

                <Stack
                  style={{
                    backgroundColor: "#e5e3fd",
                    height: "20px",
                    padding: "10px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>
                    Certifications
                  </Typography>
                </Stack>
                <Stack style={{ padding: "10px" }} direction="column">
                  <Stack style={{ padding: "10px" }} direction="column">
                    {userCertificates?.map((el: any, index: number) => {
                      return (
                        <React.Fragment key={index}>
                          <Typography
                            style={{
                              color: "#000000",
                              fontSize: "14px",
                              fontWeight: "550",
                              margin: "10px 0px",
                            }}
                          >
                            {el?.certificateName}
                          </Typography>

                          <Stack direction="column" spacing={1}>
                            <Stack direction="row" spacing={1}>
                              <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                {el?.institute}
                              </Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                              <img src="/images/Calendar-new.png" width="20px"></img>
                              <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                Duration: {el?.courseDuration && formatDuration(el.courseDuration)}
                              </Typography>
                            </Stack>
                            {el?.courseExpiry ? (
                              <Stack direction="row" spacing={1}>
                                <img src="/images/complete-profile/Course Expiry Date.svg" width="20px"></img>
                                <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                  Certification Expiry Date: {moment(el?.courseExpiry)?.format("DD/MM/YYYY")}
                                </Typography>
                              </Stack>
                            ) : null}

                            {el?.certificateReceived && (
                              <Stack direction="row" spacing={1}>
                                <img src="/images/Tick.png" width="20px"></img>
                                <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                  Received Certificate
                                </Typography>
                              </Stack>
                            )}
                            {index < userCertificates.length - 1 && <Divider sx={{ mt: 2, mb: 1 }} variant="middle" />}
                          </Stack>
                        </React.Fragment>
                      );
                    })}
                  </Stack>
                </Stack>
              </Box>
            )}

            {activeTab1 === 2 && (
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "left", padding: "8px" }}>
                <img src="/images/connector-image.png" alt="Connector" width="150px" />
                <Typography style={{ fontSize: "18px", fontWeight: "600", color: "#1F2235", marginTop: "10px" }}>
                  {userPersonality?.map((el: any) => el?.displayPersonalityType).join(", ")}
                </Typography>
                <Typography style={{ fontSize: "14px", fontWeight: "400", color: "#1F2235", marginTop: "10px" }}>
                  {userPersonality
                    ?.map((el: any) => el?.typeDescriptors)
                    .join("\n")
                    .split("\n")
                    .map((line: any, index: any) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                </Typography>

                <Button
                  onClick={toggleReportView}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#756DE9",
                    cursor: "pointer",
                    gap: 1,
                    mt: 2,
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "1px solid #756DE9",
                    backgroundColor: "transparent",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#F8F7FF",
                      border: "1px solid #756DE9",
                    },
                  }}
                >
                  View Full Report <ArrowForward sx={{ fontSize: "18px" }} />
                </Button>

                <Divider sx={{ marginTop: "20px", marginBottom: "20px" }}></Divider>
              </Box>
            )}
              </>
            )}
          </Box>

          {/* Button section at bottom */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: "#1F2235",
              borderRadius: "0px 0px 8px 8px",
              bgcolor: "#1F2235",
              py: 1,
              height: "30px",
              marginTop: "auto",
            }}
          >
            <Button
              onClick={handleShortlistAction}
              disabled={loadingShortlist}
              sx={{ 
                fontSize: "14px", 
                weight: "400", 
                color: "#fff", 
                textAlign: "center", 
                width: "50%",
                opacity: loadingShortlist ? 0.7 : 1,
                "&:disabled": {
                  color: "#fff",
                }
              }}
            >
              {loadingShortlist ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={14} sx={{ color: '#fff' }} />
                  <Typography sx={{ fontSize: '14px' }}>
                    {selectedApplicantDetails?.applicationStatus === "SHORTLIST" ? "Updating..." : "Shortlisting..."}
                  </Typography>
                </Box>
              ) : (
                <>
                  {selectedApplicantDetails?.applicationStatus === "SHORTLIST" 
                    ? (activeApplicantsTab === 1 
                        ? (() => {
                            console.log('Shortlist tab - isPrimary:', selectedApplicantDetails?.isPrimary);
                            return selectedApplicantDetails?.isPrimary ? "Secondary List" : "Primary List";
                          })()
                        : "Shortlisted") 
                    : "Shortlist"}{" "}
                  <img
                    src={(() => {
                      let iconPath = "";
                      if (selectedApplicantDetails?.applicationStatus === "SHORTLIST") {
                        if (activeApplicantsTab === 1) {
                          // In shortlist tab
                          iconPath = selectedApplicantDetails?.isPrimary ? "/images/down-arrow.svg" : "/images/up-arrow.svg";
                        } else {
                          // In applied tab
                          iconPath = "/images/Group.png";
                        }
                      } else {
                        // Not shortlisted
                        iconPath = "/images/outlined-heart.svg";
                      }
                      console.log('Selected icon path:', iconPath);
                      return iconPath;
                    })()}
                    width="17px"
                    height="17px"
                    style={{ marginLeft: "8px" }}
                  />
                </>
              )}
            </Button>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ marginLeft: 2, marginRight: 2, height: "24px", backgroundColor: "#ffffff", marginTop: "6px" }}
            />
            <Button
              onClick={handleOpenModal}
              sx={{ fontSize: "14px", weight: "400", color: "#fff", textAlign: "center", width: "50%" }}
            >
              Reach Out{" "}
              <img
                src="/images/client-website/reach-out.png"
                width="15px"
                height="15px"
                style={{ marginLeft: "8px" }}
              ></img>
            </Button>

            {/* Modal Component */}
            <Modal open={openModal} onClose={handleCloseModal}>
              <Box sx={styles.modalContent}>
                <Typography variant="h6" component="h2">
                  Reach out to the candidate
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid #756DE9",
                    borderRadius: "10px",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px", width: "50%" }}
                  >
                    <Grid sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px" }}>
                      <img src={selectedApplicantDetails?.profilePicturePath} width="50px" height="50px"></img>
                      <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                        <Typography sx={{ fontSize: "13px", color: "#000105", fontWeight: "400" }}>
                          {selectedApplicantDetails?.fullName}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#B56E00",
                            fontWeight: "600",
                            backgroundColor: "#EDCD5A5E;",
                            padding: "2px 5px",
                            borderRadius: "100px",
                          }}
                        >
                          {selectedApplicantDetails?.applicationStatus}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    <Box sx={{ display: "flex", flexDirection: "column", alignContent: "center", gap: 1 }}>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <img src="/images/Call-icon.png" width="20"></img>
                        <a style={{ textDecoration: "none", color: "#756DE9" }} href={`tel:${phoneNumber}`}>
                          {phoneNumber}
                        </a>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <img src="/images/Email_icon.png" width="20" height="18"></img>
                        <a
                          style={{ textDecoration: "none", color: "#756DE9", fontSize: "16px", fontWeight: "400" }}
                          href={`mailto:${email}`}
                        >
                          {email}
                        </a>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Divider sx={{ marginY: 2 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Button
                    onClick={handleCloseModal}
                    variant="contained"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "99px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      width: "12%",
                      color: "#000000",
                      padding: "10px 50px",
                      "&:hover ": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleJobAction("ACCEPTED")}
                    disabled={loadingReachout}
                    sx={{
                      backgroundColor: "#756DE9",
                      color: "#fff",
                      borderRadius: "50px",
                      padding: "10px 40px",
                      opacity: loadingReachout ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: "#756DE9", // Keep the same background color on hover
                      },
                      "&:disabled": {
                        backgroundColor: "#756DE9",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingReachout ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: '16px' }}>Processing...</Typography>
                      </Box>
                    ) : (
                      "Done"
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Divider
              orientation="vertical"
              flexItem
              sx={{ marginLeft: 2, marginRight: 2, height: "24px", backgroundColor: "#ffffff", marginTop: "6px" }}
            />
            <Button
              onClick={handleOpenModalDecline}
              sx={{ 
                fontSize: "14px", 
                weight: "400", 
                color: selectedApplicantDetails?.applicationStatus === "DECLINED" ? "#4CAF50" : "#FD794B", 
                textAlign: "center", 
                width: "50%" 
              }}
            >
              {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"}{" "}
              <img
                src={selectedApplicantDetails?.applicationStatus === "DECLINED" ? "/images/tick-new.png" : "/images/client-website/reject.png"}
                width="12px"
                height="12px"
                style={{ marginLeft: "8px" }}
                alt={selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"}
              ></img>
            </Button>

            {/* Modal Component */}
            <Modal open={openModalDecline} onClose={handleCloseModalDecline}>
              <Box sx={styles.modalContentDecline}>
                <Typography variant="h6" component="h2">
                  {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept candidate" : "Decline candidate"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #756DE9",
                  }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px" }}>
                    <img src={selectedApplicantDetails?.profilePicturePath} width="50px" height="50px"></img>
                    <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <Typography sx={{ fontSize: "13px", color: "#000105", fontWeight: "400" }}>
                        {selectedApplicantDetails?.fullName}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#B56E00",
                          fontWeight: "600",
                          backgroundColor: "#EDCD5A5E;",
                          padding: "2px 5px",
                          borderRadius: "100px",
                        }}
                      >
                        {selectedApplicantDetails?.applicationStatus}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Divider sx={{ marginY: 2 }} />

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, }}>
                  <Button
                    onClick={handleCloseModalDecline}
                    variant="contained"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "99px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      width: "12%",
                      color: "#000000",
                      padding: "10px 50px",
                      "&:hover ": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleJobAction(selectedApplicantDetails?.applicationStatus === "DECLINED" ? "APPLIED" : "DECLINED")}
                    disabled={loadingDecline}
                    sx={{
                      backgroundColor: "#756DE9",
                      color: "#fff",
                      borderRadius: "50px",
                      padding: "10px 40px",
                      opacity: loadingDecline ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: "#756DE9", // Keep the same background color on hover
                      },
                      "&:disabled": {
                        backgroundColor: "#756DE9",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingDecline ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: '16px' }}>
                          {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accepting..." : "Declining..."}
                        </Typography>
                      </Box>
                    ) : (
                      selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* Best Fit Modal Component */}
            {canShowBestFit() && (
            <Modal
              open={openBestFitModal}
              onClose={toggleBestFitModal}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "16px" : "20px",
              }}
            >
              <Box sx={{
                position: "relative",
                width: isMobile ? "calc(100vw - 32px)" : "450px",
                maxWidth: isMobile ? "400px" : "450px",
                maxHeight: isMobile ? "calc(100vh - 32px)" : "auto",
                backgroundColor: "white",
                borderRadius: isMobile ? "12px" : "16px",
                padding: isMobile ? "20px" : "24px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
                outline: "none",
                overflow: "auto",
              }}>
                {/* Header with icon */}
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: isMobile ? "16px" : "20px",
                  flexDirection: isMobile ? "column" : "row",
                  textAlign: isMobile ? "center" : "left",
                }}>
                  <Box sx={{
                    width: isMobile ? "40px" : "48px",
                    height: isMobile ? "40px" : "48px",
                    borderRadius: "50%",
                    backgroundColor: "#E8F5E8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: isMobile ? "0" : "16px",
                    marginBottom: isMobile ? "12px" : "0",
                  }}>
                    <img src="/images/Tick.png" width={isMobile ? "20px" : "24px"} height={isMobile ? "20px" : "24px"} alt="Best Fit" />
                  </Box>
                  <Typography variant="h5" component="h2" sx={{
                    fontSize: isMobile ? "18px" : "20px",
                    fontWeight: "600",
                    color: "#1F2235",
                    margin: 0,
                  }}>
                    {selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'}
                  </Typography>
                </Box>

                {/* Description */}
                <Typography sx={{
                  fontSize: isMobile ? "13px" : "14px",
                  color: "#666666",
                  marginBottom: isMobile ? "16px" : "20px",
                  lineHeight: 1.5,
                  textAlign: isMobile ? "center" : "left",
                }}>
                  {selectedApplicantDetails?.isBestFit 
                    ? 'Are you sure you want to remove this candidate from the best fit status? This action will remove their top choice highlight.'
                    : 'Are you sure you want to mark this candidate as the best fit for this position? This action will highlight them as your top choice.'
                  }
                </Typography>

                {/* Candidate Info */}
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: isMobile ? "12px" : "16px",
                  borderRadius: "12px",
                  backgroundColor: "#F8F9FA",
                  border: "1px solid #E8F5E8",
                  marginBottom: isMobile ? "20px" : "24px",
                }}>
                  <img
                    src={selectedApplicantDetails?.profilePicturePath}
                    width={isMobile ? "40px" : "50px"}
                    height={isMobile ? "40px" : "50px"}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                    alt="Candidate"
                  />
                  <Box sx={{ marginLeft: isMobile ? "10px" : "12px", flex: 1 }}>
                    <Typography sx={{
                      fontSize: isMobile ? "14px" : "16px",
                      color: "#1F2235",
                      fontWeight: "500",
                      marginBottom: "4px",
                    }}>
                      {selectedApplicantDetails?.fullName}
                    </Typography>
                    <Box sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: isMobile ? "11px" : "12px",
                      fontWeight: "600",
                    }}>
                      <img src="/images/Tick.png" width="12px" height="12px" style={{ marginRight: "4px" }} />
                      BEST FIT CANDIDATE
                    </Box>
                  </Box>
                </Box>

                {/* Action Buttons */}
                <Box sx={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-end",
                  gap: isMobile ? "8px" : "12px",
                  flexDirection: isMobile ? "column" : "row",
                }}>
                  <Button
                    onClick={toggleBestFitModal}
                    disabled={loadingBestFit}
                    variant="outlined"
                    fullWidth={isMobile}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      fontSize: isMobile ? "15px" : "14px",
                      fontWeight: "500",
                      color: "#666666",
                      padding: isMobile ? "12px 24px" : "10px 24px",
                      textTransform: "none",
                      minHeight: isMobile ? "48px" : "auto",
                      opacity: loadingBestFit ? 0.7 : 1,
                      "&:hover": {
                        borderColor: "#CCCCCC",
                        backgroundColor: "#F5F5F5",
                      },
                      "&:disabled": {
                        borderColor: "#E0E0E0",
                        color: "#666666",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleBestFitAction}
                    disabled={loadingBestFit}
                    fullWidth={isMobile}
                    sx={{
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                      color: "#fff",
                      borderRadius: "8px",
                      fontSize: isMobile ? "15px" : "14px",
                      fontWeight: "500",
                      padding: selectedApplicantDetails?.isBestFit ? (isMobile ? "12px 32px" : "10px 32px") : (isMobile ? "12px 24px" : "10px 24px"),
                      minWidth: selectedApplicantDetails?.isBestFit ? (isMobile ? "200px" : "180px") : "auto",
                      textTransform: "none",
                      minHeight: isMobile ? "48px" : "auto",
                      opacity: loadingBestFit ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: selectedApplicantDetails?.isBestFit ? "#d32f2f" : "#45a049",
                      },
                      "&:disabled": {
                        backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingBestFit ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={isMobile ? 18 : 16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: isMobile ? '15px' : '14px' }}>
                          {selectedApplicantDetails?.isBestFit ? 'Removing...' : 'Marking...'}
                        </Typography>
                      </Box>
                    ) : (
                      selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>
            )}
          </Box>
        </Box>
      </Box>

      {/* Comment Popup */}
      <CommentPopup
        open={openCommentModal}
        onClose={toggleCommentModal}
        jobId={jobId ? parseInt(jobId) : undefined}
        receiverId={selectedApplicantDetails?.userId}
      />

      {/* Report View */}
        <ReportView
          open={openReportView}
          onClose={toggleReportView}
          candidateName={selectedApplicantDetails?.fullName || fullName}
          applicantId={selectedApplicantDetails?.userId}
          reportData={applicantReport}
          personalityData={applicantPersonality}
          topicScoreData={applicantTopicScore}
          scoreBandData={applicantScoreBand}
        />

      {/* Share Popup */}
      <SharePopup
        open={openShareModal}
        onClose={toggleShareModal}
        selectedApplicantDetails={selectedApplicantDetails}
        selectedCandidates={selectedCandidates}
        jobId={jobId ? parseInt(jobId) : undefined}
        onShareSuccess={handleShareSuccess}
      />

      {/* Share Success Popup */}
      <ShareSuccessPopup
        open={openShareSuccessModal}
        onClose={toggleShareSuccessModal}
        shareUrl={shareSuccessUrl}
      />

      <ConfirmRecommendPopup
        open={confirmRecommendOpen}
        onClose={() => setConfirmRecommendOpen(false)}
        onConfirm={handleConfirmRecommend}
        jobs={(Array.isArray(organizationJobs) ? organizationJobs : (organizationJobs as any)?.records ?? []).map((j: any) => ({
          jobId: j.jobId ?? j.job_id,
          title: j.title ?? j.jobTitle ?? j.jobName ?? j.job_name,
          jobTitle: j.jobTitle ?? j.job_name,
          jobName: j.jobName ?? j.job_name,
          companyName: j.companyName ?? j.company_name,
          jobRole: j.jobRole ?? j.job_role ?? j.jobRoles ?? j.job_roles ?? j.role,
          status: j.status,
        }))}
        loadingJobs={loadingOrganizationJobs}
        defaultJobId={jobId ? parseInt(jobId, 10) : null}
        candidates={selectedCandidates?.map((c) => ({
          fullName: c.fullName,
          email: c.email,
          profilePicturePath: c.profilePicturePath,
          profileImage: c.profileImage,
        })) ?? []}
        isSubmitting={recommendSubmitting}
      />

      {jobId && (
        <RecommendJobModal
          open={recommendJobModalOpen}
          onClose={() => {
            setRecommendJobModalOpen(false);
            setRecommendPreSelectedIds([]);
          }}
          jobId={parseInt(jobId)}
          jobTitle={b2bJobDetails?.title || b2bJobDetails?.jobTitle || b2bJobDetails?.jobName}
          initialSelectedCandidateIds={recommendPreSelectedIds}
        />
      )}

      {/* Password Modal */}
      <Modal open={openPasswordModal} onClose={() => {}}>
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "32px",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          outline: "none",
        }}>
          <Box sx={{ textAlign: "center", marginBottom: "24px" }}>
            <Box sx={{ 
              width: "48px", 
              height: "48px", 
              backgroundColor: "#F5F5F5", 
              borderRadius: "50%", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              margin: "0 auto 16px auto",
              border: "2px solid #E0E0E0"
            }}>
              <Typography sx={{ fontSize: "24px", color: "#666" }}>🔒</Typography>
            </Box>
            <Typography variant="h5" sx={{ color: "#1F2235", fontWeight: "600", marginBottom: "8px" }}>
              Password Required
            </Typography>
            <Typography variant="body2" sx={{ color: "#666" }}>
              This share link is password protected. Please enter the password to continue.
            </Typography>
          </Box>

          <TextField
            fullWidth
            type="password"
            label="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError(''); // Clear error when user types
            }}
            error={!!passwordError}
            helperText={passwordError}
            sx={{
              marginBottom: "24px",
              '& .MuiOutlinedInput-root': {
                borderRadius: "999px",
                backgroundColor: passwordError ? "rgba(211, 47, 47, 0.02)" : "rgba(75, 68, 212, 0.02)",
                boxShadow: passwordError ? "inset 0px 0px 11px 2px rgba(211, 47, 47, 0.08)" : "inset 0px 0px 11px 2px rgba(75, 68, 212, 0.08)",
                fontFamily: "DM Sans",
                fontSize: "14px",
                fontWeight: 400,
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
              "& .MuiInputLabel-root": {
                fontFamily: "DM Sans",
                fontSize: "14px",
                fontWeight: 400,
                color: passwordError ? "#d32f2f" : "#666",
              },
              "& .MuiFormHelperText-root": {
                fontFamily: "DM Sans",
                fontSize: "12px",
                marginTop: "4px",
              },
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && !isValidatingPassword) {
                handlePasswordSubmit();
              }
            }}
          />

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handlePasswordSubmit}
              disabled={!password.trim() || isValidatingPassword}
              sx={{
                backgroundColor: "#756DE9",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                padding: "10px 32px",
                textTransform: "none",
                minWidth: "120px",
                "&:hover": {
                  backgroundColor: "#5f5bc4",
                },
                "&:disabled": {
                  backgroundColor: "#E0E0E0",
                  color: "#999",
                },
              }}
            >
              {isValidatingPassword ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <CircularProgress size={16} sx={{ color: "#999" }} />
                  Validating...
                </Box>
              ) : (
                "Continue"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ClientJobDetails;
